import React from "react";

const PortfolioCard = ({ projectName, tags, img }) => {
  return (
    <div className="bg-teal-200 border  bg-opacity-60 rounded-sm  p-4 mb-6 max-w-full max-h-full transition-transform duration-500 hover:scale-105 shadow-lg hover:shadow-2xl">
      <div className="bg-teal-400 border-[2px] hover:bg-teal-200 hover:bg-opacity-20  bg-opacity-50 rounded-sm rotate-3 p-4 mb-6 max-w-full max-h-full transition-transform duration-500 hover:scale-105 shadow-lg hover:shadow-2xl">
        {/* Image Section */}
        <div className="flex justify-center items-center bg-white bg-opacity-50 rounded-lg mb-4 border m-3 overflow-hidden relative group">
          <img
            src={img}
            alt="Illustration Design"
            className="w-full h-full object-cover  transform transition-transform duration-500 group-hover:scale-110 "
          />
        </div>

        {/* Project Name */}
        <h3 className="text-xl font-bold mb-6 text-white ml-2">
          {projectName}
        </h3>

        <div className="flex flex-row flex-wrap gap-2 ml-2 overflow-hidden relative mx-4 mb-4">
          <div className="flex  gap-2 animate-slide">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="bg-white flex justify-center items-center mx-2 text-teal-950 rounded-full px-2 py-1 text-sm border transition-transform duration-300 whitespace-nowrap"
                style={{ minWidth: "fit-content" }}
              >
                {tag}
              </span>
            ))}
            {tags.map((tag, index) => (
              <span
                key={`duplicate-${index}`}
                className="bg-white flex justify-center items-center mx-2 text-teal-950 rounded-full px-2 py-1 text-sm border transition-transform duration-300 whitespace-nowrap"
                style={{ minWidth: "fit-content" }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioCard;
